
import Vue, { PropType } from 'vue'
import { PublicPlace } from '@/models'

import draggable from 'vuedraggable'

import WebsitePublicPlaceListHeader from './WebsitePublicPlaceListHeader.vue'
import WebsitePublicPlaceListItem from './WebsitePublicPlaceListItem.vue'

export default Vue.extend({
  name: 'WebsitePublicPlaceList',

  components: {
    WebsitePublicPlaceListHeader,
    WebsitePublicPlaceListItem,
    draggable
  },

  props: {
    value: Array as PropType<Array<PublicPlace>>,
  },

  computed: {
    bindList: {
      get(): PublicPlace[] {
        return this.value
      },

      set(list: PublicPlace[]): void {
        this.$emit('input', list)
      }
    }
  }
})
